/**
 * Formats a numeric amount into a localized INR (₹) currency string.
 * @param {number|string} amount - The price/amount to format.
 * @param {boolean} [showDecimals=false] - Whether to include decimal places.
 * @returns {string} Formatted Indian Rupee currency string (e.g., ₹12,500 or ₹1,25,000).
 */
export const formatCurrency = (amount, showDecimals = false) => {
  let numericAmount = amount;

  if (typeof numericAmount !== 'number') {
    numericAmount = Number(numericAmount) || 0;
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(numericAmount);
};

export default formatCurrency;